import * as React from 'react';
import { Space, Empty } from 'antd';
import * as store from '../../store';
import DimensionTable from '../DimensionTable';

const Breakdown = () => {
  const dimensionTables = store.useDashboardDimensionTables();
  const propagations = store.useDashboardPropagationSettings();

  return !dimensionTables.length ? (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="Add a table to view dimensional breakdown"
      styles={{
        image: {
          height: 100,
        },
      }}
    />
  ) : (
    <Space direction="vertical" size={16} style={{ display: 'flex' }}>
      {dimensionTables.map(({ dimension, aggregations, order_by }) => (
        <DimensionTable
          key={dimension}
          dimension={dimension}
          aggregations={aggregations}
          propagation={propagations[dimension]}
          sort={order_by}
        />
      ))}
    </Space>
  );
};

export default React.memo(Breakdown);
